__turbopack_context__.v({
  "closeBtn": "Bi1NKG_closeBtn",
  "content": "Bi1NKG_content",
  "overlayContent": "Bi1NKG_overlayContent",
  "root": "Bi1NKG_root",
});
